<form class="mr-5 ml-5 mt-5 mb-3" (ngSubmit)="onPagoParafiscal()">
  <section class="row border-bottom mb-4">
    <section class="col-12">
      <app-ayudas
        [ayuda]="ayudaService.pagoParafiscal(
          datoSolicitudSharedModel.tipo_solicitud, 
          datoSolicitudSharedModel.tipo_rnt , 
          rnt.sub_categoria_id,
          rnt.estado_rnt_id,
          rnt.estado_solicitud_id)">
      </app-ayudas>
      <header class="row form-group d-flex align-items-center">
        <figure class="m-auto">
          <img src="../../../../../../../../assets/icons/info-establecimiento.png"
            class="d-inline-block p-2 rounded-circle" alt="" height="60">
        </figure>
        <div class="col">
          <label class="text-muted small mb-0">Pago aportes <br><strong
              class="h5 text-body">Parafiscales</strong></label>
        </div>
      </header>
      <footer>
        <p> <strong>Obligación pago contribución parafiscal</strong> </p>
        <p>Ventas anuales</p>
        <p>
          <!-- La solicitud se encuentra registrada con la subcategoría <strong>{{rnt.descripcion_tipo_establecimiento}}</strong>.
          Por lo tanto, si sus ingresos anuales superan los {{tope}} SMLV <strong>({{ desc_tope | currency: 'COP' }})</strong>,
          especifique los ingresos anuales para determinar si
          debe realizar aportes Parafiscales. -->
          <!-- Especifique el valor de las ventas que obtuvo entre el 1 de enero y 31 de diciembre del año 2017, para
          determinar si debe realizar la contribución parafiscal en el año 2018. -->
          {{textoPagoAportesParafiscales}}
        </p>
      </footer>
      <form [formGroup]="pagoParaficalForm" (ngSubmit)="onPagoParafiscal()">
        <div class="form-group">
          <label class="text-muted">Ingresos anuales (Digite sin puntos, ni comas)</label>
          <input class="form-control" formControlName="ingreso_anual" (change)="onChangeIngreso()" />
        </div>
        <label class="text-muted">Se encuentra obligado a realizar aportes Parafiscales</label>
        <div class="form-row ml-4">
          <div class="col-sm-12 col-md-6 form-group">
            <input type="checkbox" class="form-check-input" [checked]="pagoParaficalForm.value.pago_parafiscal"
              [disabled]="true" />
            <label class="form-check-label text-muted">Si</label>
          </div>
          <div class="col-sm-12 col-md-6 form-group">
            <input type="checkbox" class="form-check-input" [checked]="!pagoParaficalForm.value.pago_parafiscal"
              [disabled]="true" />
            <label class="form-check-label text-muted">No</label>
          </div>
        </div>
      </form>
    </section>
  </section>
  <footer class="text-right p-3">
    <button type="button" class="btn btn-outline-primary paso-capacidad-info-btn-inicio mr-2 pl-4 pr-4"
      (click)="onRegresarPaso()">{{boton_atras}}</button>
    <button type="submit" [disabled]="!pagoParaficalForm.valid"
      class="btn btn-primary paso-capacidad-btn-inicio">{{boton}}</button>
  </footer>
</form>
